export const USER_CHECK_ROLE_FILTERS = {
  OPERATOR: "Проверки УО",
  LIQUIDITY_PROVIDER: "Проверки ПЛ",
  CUSTOMER: "Проверки УВЭД",
};
